import React from 'react'
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import checkPermission from '../../../../../Components/Hooks/PermissionHook';

function PushChangesBtn({onClick}) {
  
  const selectMenuPath = createSelector(state => state.MenuData, state => ({
    brandPath: state.brandPath,
    marketPath: state.marketPath,
  }));
  const { brandPath, marketPath } = useSelector(selectMenuPath);
  const selectVersion = createSelector(state => state.Campaign, state => ({
    currentVersion: state.currentVersion
  }));
  const {currentVersion} = useSelector(selectVersion);

  if (checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), "campaignPublish")) {
    return (
      <button className='btn btn-warning' onClick={() => onClick()}>
        <svg className='me-2' xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="10.707" height="11" viewBox="0 0 10.707 11">
          <defs>
            <rect id="Rectangle_51" data-name="Rectangle 51" width="10.707" height="11" fill="none" />
          </defs>
          <g id="Group_130" data-name="Group 130" transform="translate(0 0)">
            <g id="Group_129" data-name="Group 129" transform="translate(0 0)">
              <path id="Path_42" data-name="Path 42" d="M4.687,11V5.786L3.032,7.455,2.08,6.489,5.361,3.208l3.3,3.281-.981.967L6.02,5.786V11ZM0,4.116V1.355A1.3,1.3,0,0,1,.4.4,1.28,1.28,0,0,1,1.333,0H9.374a1.293,1.293,0,0,1,.921.4,1.279,1.279,0,0,1,.412.951V4.116H9.374V1.348H1.333V4.116Z" transform="translate(0 0)" fill="#030541" />
            </g>
          </g>
        </svg>
        Push Changes
      </button>
    )
  }
}

export default PushChangesBtn
